import {
  ReCaptchaSetting,
  FormAuthenticatedData,
  FormAccessReportSetting,
} from 'backend';
import { GlobalErrors } from 'models';
import { useEffect, RefObject, useRef } from 'react';
import { InputData } from 'shared';
import { useFileUploadInitialize } from '../../hooks/useFileUploadInitialize';
import { CurrentFormPage, useCurrentForm } from '../../store';
import { useExternalMeasurementTag } from '../useExternalMeasurementTag';
import { useTracking } from '../useTracking';

type UseInitPageReturnType = {
  currentFormPage: CurrentFormPage;
  inputData: InputData;
  reCaptchaSetting?: ReCaptchaSetting;
  mainContentRef: RefObject<HTMLDivElement>;
  globalErrors?: GlobalErrors;
  authentication?: FormAuthenticatedData;
  accessReportSetting?: FormAccessReportSetting;
};

export const useInitPage = (): UseInitPageReturnType => {
  const {
    currentFormPage,
    inputData,
    reCaptchaSetting,
    trackingSetting,
    needsScrollTopAndFocus,
    globalErrors,
    authentication,
    externalMeasurementTag,
    accessReportSetting,
  } = useCurrentForm();
  const mainContentRef = useRef<HTMLDivElement>(null);
  useTracking(trackingSetting);
  useExternalMeasurementTag(externalMeasurementTag);
  useFileUploadInitialize();
  useEffect(() => {
    if (needsScrollTopAndFocus) {
      scrollTo({
        top: 0,
        left: 0,
      });
      mainContentRef.current?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFormPage]);

  return {
    currentFormPage,
    inputData,
    reCaptchaSetting,
    mainContentRef,
    globalErrors,
    authentication,
    accessReportSetting,
  };
};
